import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "@/v5/lib/utils";

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        // SCRUM-1444: "field labels are clipped ('Da...', 'Tim...')". `leading-none` is
        // line-height 1, which leaves no room for a descender, so the tail of a `y` or `p`
        // is cut by the line box. Restoring it below `md` only, because desktop is not
        // reported and every v5 form uses this label.
        "max-md:leading-tight",
        className
      )}
      {...props}
    />
  );
}

export { Label };
